import React from 'react';

import { CourseCards } from './CourseCards';
import { Badge, DisabledOverlayStyled, Header, LockedItemsBannerStyled, Title } from './styles';
import { useCourseCards } from './CourseCards/hooks';
import { Skeleton } from '@/ui/Skeleton';
import { BadgeLabel } from '@/ui/Label/variants/BadgeLabel';
import { makeNamespacedComponent } from '@/ui/utils';
import { LearningItemProps } from './types';
import { Icon } from '@/ui/Icon';

const LearningItemsBase = ({ assignment, hasAccess }: LearningItemProps): JSX.Element => {
  const { processedTotal, processedCards, loading } = useCourseCards({ assignment });

  if (loading) {
    return <LearningItems.LoadingState />;
  }

  return (
    <div>
      <Header>
        <Title>Suggested learning</Title>
        <Badge badgeVariant="badge-text" text={processedTotal.toString()} />
      </Header>
      {!hasAccess && (
        <LockedItemsBannerStyled>
          <Icon icon="lock" /> Your assignment starts on {assignment.startAt}
        </LockedItemsBannerStyled>
      )}
      {processedCards && (
        <DisabledOverlayStyled hasAccess={hasAccess}>
          <CourseCards cards={processedCards} />
        </DisabledOverlayStyled>
      )}
    </div>
  );
};

const LoadingState = (): JSX.Element => (
  <div>
    <Header>
      <Skeleton width={216} height={40} />
      <BadgeLabel.LoadingState badgeVariant="badge-text" overrideWidth={23} />
    </Header>
    <CourseCards.LoadingState />
  </div>
);

const LearningItems = makeNamespacedComponent(LearningItemsBase, {
  LoadingState,
});

export { LearningItems };
